const DexpApiUrls = {
  TRACK: ` ${process.env.REACT_APP_USER_DEXP_URL}/dexp/unified-header/getByContainerNo`,
  TRACK_CCN: ` ${process.env.REACT_APP_USER_DEXP_URL}/dexp/unified-header/getByCcn`
}

export default DexpApiUrls
